import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import validate from 'validate.js';
import { useHistory } from 'react-router-dom';
import useLocalStorage from 'hooks/useLocalStorage';

import Container from 'components/common/Container';
import Button from 'components/common/Button';
import TextInput from 'components/forms/TextInput';
import { withAuctionCore } from 'agent';
import useStores from 'hooks/useStore';

import DesktopBanner from 'components/common/DesktopBanner';
import useResponsive from 'hooks/useResponsive';
import NpaWidget from 'NpaWidget';

import {
  ErrorWrapper, ErrorText, Wrapper, Row,
} from './styles';

import constraints from './validation';

const Login = ({ auctioncore }) => {
  const history = useHistory();

  const [counter, setCounter] = useState(0);

  const { UserStore, UIStore } = useStores();
  const { isLargeView } = useResponsive();
  const [token, setToken] = useLocalStorage('token', '');

  const [isNativeView, setIsNativeView] = useLocalStorage('isNativeView');

  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [errors, setErrors] = useState([]);

  useEffect(() => {
    if (username.length > 0 || password.length > 0) {
      validate.async({ username, password }, constraints)
        .then(() => {
          setErrors([]);
        })
        .catch((err) => setErrors(err));
    }
  }, [username, password]);

  const Submit = async () => {
    try {
      await validate.async({ username, password }, constraints);
    } catch (err) {
      setErrors(err);
      return;
    }

    UIStore.setLoading(true);

    try {
      const res = await auctioncore.doSignIn(username, password);
      if (res.data?.sessionToken) {
        UserStore.setToken(res.data.sessionToken);
        setToken(res.data.sessionToken);
        UIStore.setLoading(false);
        history.push('Search');
        return;
      }
      throw new Error(res.response.data);
    } catch (err) {
      UIStore.setLoading(false);
      UIStore.setShowError(true, err.message);
    }
  };

  return (
    <Container>
      {isLargeView && <DesktopBanner />}
      <Wrapper>
        <Row>
          <TextInput key="emailinput" error={errors?.username} placeholder="Username" value={username} onChange={(e) => setUsername(e.target.value)} />
          {errors.username && (
          <ErrorWrapper>
            <ErrorText>
              {errors.username}
            </ErrorText>
          </ErrorWrapper>
          )}
        </Row>
        <Row>
          <TextInput type="password" error={errors?.password} placeholder="Password" value={password} onChange={(e) => setPassword(e.target.value)} />
          {errors.password && (
          <ErrorWrapper>
            <ErrorText>
              {errors.password}
            </ErrorText>
          </ErrorWrapper>
          )}
        </Row>
        <Button onClick={() => Submit()}>Login</Button>
        <NpaWidget />
      </Wrapper>
    </Container>
  );
};

Login.propTypes = {
  auctioncore: PropTypes.object.isRequired,
};

export default withAuctionCore(Login);
